import RefereeFightsApp from "./RefereeFightsApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(RefereeFightsApp);
